import React from 'react';
import { Outlet } from 'react-router-dom';
import SimulationBanner from './SimulationBanner.tsx';
import { useSDK } from '../../context/SDKContext.tsx';

export default function PublicLayout(): React.ReactElement {
  const { isSimulated, reconnect } = useSDK();
  return (
    <div className="flex flex-col h-screen bg-background">
      {isSimulated && <SimulationBanner onReconnect={reconnect} />}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
